import type {
  Artist,
  ArtistOverview,
  DefaultResponseBody,
  ListResponseBody,
  Playlist,
} from "@gerama/types";
import type { ApiClient } from "../client";

export function createCoreArtistsApi(client: ApiClient) {
  return {
    list: (params: { page?: number; limit?: number } = {}, signal?: AbortSignal) =>
      client
        .request<ListResponseBody<Artist>>("/artists", { query: { ...params }, signal })
        .then((res) => res.data ?? { list: [], count: 0 }),

    /** The whole artist page in one call (cached server-side); a token adds the caller's follow / suggest-less state. */
    overview: (id: number | string, signal?: AbortSignal) =>
      client
        .request<DefaultResponseBody<ArtistOverview>>(`/artists/${id}/overview`, { signal })
        .then((res) => res.data as ArtistOverview),

    /** Playlists that feature the artist's songs. */
    featuring: (id: number, params: { page?: number; limit?: number } = {}, signal?: AbortSignal) =>
      client
        .request<ListResponseBody<Playlist>>("/playlists", {
          query: { containsArtistId: id, ...params },
          signal,
        })
        .then((res) => res.data ?? { list: [], count: 0 }),

    detail: (id: number | string, signal?: AbortSignal) =>
      client
        .request<DefaultResponseBody<Artist>>(`/artists/${id}`, { signal })
        .then((res) => res.data as Artist),
  };
}
